var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('nuvei-card-form',{attrs:{"loading":_vm.loading,"nuveiCardData":_vm.nuveiCard,"formErrors":_vm.formErrors},on:{"nuveiCardSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }